'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _buttonGroup = require('../button-group');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Form = function Form(_ref) {
  var children = _ref.children,
      classNames = _ref.classNames,
      _ref$errors = _ref.errors,
      errors = _ref$errors === undefined ? [] : _ref$errors,
      footer = _ref.footer,
      icon = _ref.icon,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === undefined ? false : _ref$isLoading,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled,
      noValidate = _ref.noValidate,
      styles = _ref.styles,
      _ref$submit = _ref.submit,
      submit = _ref$submit === undefined ? 'Submit' : _ref$submit,
      _ref$actions = _ref.actions,
      actions = _ref$actions === undefined ? [] : _ref$actions,
      onSubmit = _ref.onSubmit,
      submitProps = _ref.submitProps,
      props = _objectWithoutProperties(_ref, ['children', 'classNames', 'errors', 'footer', 'icon', 'isLoading', 'isDisabled', 'noValidate', 'styles', 'submit', 'actions', 'onSubmit', 'submitProps']);

  var renderIcon = function renderIcon(icon) {
    return (typeof icon === 'undefined' ? 'undefined' : _typeof(icon)) === 'object' ? _react2.default.createElement(_icon2.default, _extends({ styles: styles.icon }, icon)) : _react2.default.createElement(_icon2.default, { styles: styles.icon, name: icon });
  };

  return _react2.default.createElement(
    'form',
    _extends({
      className: 'c11n-form ' + classNames.root,
      action: '/',
      method: 'POST',
      onSubmit: onSubmit,
      noValidate: noValidate
    }, props),
    _react2.default.createElement(
      'div',
      { className: classNames.fields },
      children
    ),
    errors.map(function (error, i) {
      return _react2.default.createElement(
        'div',
        {
          className: classNames.error + ' ' + (error.status && classNames[error.status]),
          key: i
        },
        error.field ? 'Field ' + error.field + ' ' : '',
        error.message
      );
    }),
    actions.length ? _react2.default.createElement(
      _buttonGroup2.default,
      { styles: styles.actions },
      submit && _react2.default.createElement(
        _button2.default,
        {
          styles: styles.submit,
          disabled: isLoading || isDisabled,
          'aria-label': submit,
          title: submit,
          type: 'submit'
        },
        _react2.default.createElement(
          'span',
          null,
          submit
        ),
        icon && renderIcon(icon)
      ),
      actions.map(function (_ref2, i) {
        var label = _ref2.label,
            icon = _ref2.icon,
            actionProps = _objectWithoutProperties(_ref2, ['label', 'icon']);

        return _react2.default.createElement(
          _button2.default,
          _extends({
            key: i,
            tag: 'a',
            styles: styles.action,
            disabled: isLoading || isDisabled,
            'aria-label': label,
            title: submit
          }, actionProps),
          _react2.default.createElement(
            'span',
            null,
            label
          ),
          icon && renderIcon(icon)
        );
      })
    ) : submit ? _react2.default.createElement(
      _button2.default,
      _extends({
        block: true,
        styles: styles.submit,
        disabled: isLoading || isDisabled,
        'aria-label': submit,
        title: submit,
        type: 'submit'
      }, submitProps),
      _react2.default.createElement(
        'span',
        null,
        submit
      ),
      icon && renderIcon(icon)
    ) : null,
    footer
  );
};

Form.propTypes = {
  /**
   * Errors to be displayed
   */
  errors: _propTypes2.default.array,

  /**
   * The form inputs and content
   */
  children: _propTypes2.default.any,

  /**
   * Additional form actions to be displayed
   */
  actions: _propTypes2.default.array,

  /**
   * Disable form inputs
   */
  isDisabled: _propTypes2.default.bool,

  /**
   * Show loading animation / disable form inputs
   */
  isLoading: _propTypes2.default.bool,

  /**
   * The submit handler that will fire once the form is submitted
   */
  onSubmit: _propTypes2.default.func.isRequired,

  /**
   * The label for the submit button
   */
  submit: _propTypes2.default.string,

  /**
   * The name of the icon to add, an object of to pass to the Icon component, or false to hide
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),

  /**
   * Props to spread over the submit Button
   */
  submitProps: _propTypes2.default.object
};

Form.defaultProps = {
  submit: 'Submit',
  icon: { name: 'chevron', size: 0.75 }
};

exports.default = (0, _withStyles2.default)(_styles2.default, _styles.keyframes)(Form);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/form/index.js
// module id = 99
// module chunks = 0